// Import Types
import type { ActivePartner, Currency, ResponseModel } from 'types';
// Import Configs
import { BackofficeRequestService, CRMRequestService } from './http.config';

const AuthHttpService = {
    signInWithPassword: (authData) => {
        return CRMRequestService.post('/User/LoginWithPassword', authData);
    },
    logout: () => {
        return CRMRequestService.post('/User/Logout');
    },
    resetPassword: (emailForReset) => {
        return CRMRequestService.post('/User/ResetPasswordRequest', JSON.stringify(emailForReset));
    },
    resetPasswordConfirm: (resetData) => {
        return CRMRequestService.post('/User/ResetPasswordConfirm', resetData);
    },
    checkAuthentication: () => {
        return BackofficeRequestService.get('/Account/CheckAuthentication');
    },
    loginWithPlatform: (token) => {
        return CRMRequestService.post('/User/LoginWithPlatform', JSON.stringify(token));
    },
    getPartners: (): Promise<ResponseModel<ActivePartner[]>> => {
        return CRMRequestService.get('/User/GetPartners');
    },
    getCurrencies: (): Promise<ResponseModel<Currency[]>> => {
        return CRMRequestService.get('/OptionsList/GetCurrencies');
    },
    getUserSettings: () => {
        return CRMRequestService.get('/User/Settings');
    },
    changePartner: (partnerId) => {
        return CRMRequestService.post(`/User/ChangePartner?partnerId=${partnerId}`);
    },
    updateSettings: (settings) => {
        return CRMRequestService.post('/User/UpdateSettings', settings);
    },
    saveLanguageSetting: (langId) => {
        return CRMRequestService.post(`/User/ChangeLanguage?newLanguage=${langId}`);
    },
};

export default AuthHttpService;
